import {
  FETCHED_REPLACEMENTS,
  START_FETCHING_REPLACEMENTS,
} from '../actionTypes';

import { ReplacementType } from './../../types/AppTypes';

interface InitialState {
  replacements: ReplacementType[];
  loading: boolean;
  error: any;
  message: any;
  user: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  replacements: [],
  loading: false,
  error: null,
  message: null,
  user: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_REPLACEMENTS:
      return {
        ...state,
        replacements: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_REPLACEMENTS: {
      const { replacements, error, message } = action.payload;
      return {
        ...state,
        replacements,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
